import script from "./LogoControl.vue?vue&type=script&lang=ts"
export * from "./LogoControl.vue?vue&type=script&lang=ts"
script.__scopeId = "data-v-1058cc64"

export default script